module.exports = __webpack_public_path__ + "static/media/YM32_3.1c88b3fa.jpg";